// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__1IDBL","parOne":"style_parOne__QUGC8","parTwo":"style_parTwo__ETsdu"};